import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  LinearProgress,
  Button,
  Tabs,
  Tab,
} from "@mui/material";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { arialFont } from "../Assets/arialFont";
import { arialBoldFont } from "../Assets/arialBoldFont";
import logo from "../../eyesoftlogo.png";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { useIntl, IntlProvider, FormattedMessage } from "react-intl";
import messages from "../../locales";
import axios from "axios";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
//import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { PieChart } from "@mui/x-charts/PieChart";
/*import {
  GaugeContainer,
  GaugeValueArc,
  GaugeReferenceArc,
  useGaugeState,
} from "@mui/x-charts/Gauge";*/
import GaugeChart from "react-gauge-chart";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../Themes/themes";

//Heatmap soru cevap modalı
interface PhotoModalProps {
  open: boolean;
  onClose: () => void;
  sessionID: number;
  sessionNote: string;
  studentName: string;
  recordDateTime: string;
  status: string;
  schoolName: string;
  provinceName: string;
  distirctName: string;
  dyslexiaPossibility: number;
  sessionType: number;
  /*lowReadingPossibility: number;
  typicalPossibility: number;*/
  answers: { [key: number]: string[] }; // Güncellenmiş prop tipi
}
interface Question {
  ID: number;
  Question: string;
  Answer1: string;
  Answer2: string;
  Answer3: string;
  Answer4: string;
  Correct: number; // Correct answer index (1-4)
  CreatedAt: string;
  UpdatedAt: string;
  DeletedAt: string | null;
}
const ReadMapModal: React.FC<PhotoModalProps> = ({
  open,
  onClose,
  sessionID,
  sessionNote,
  studentName,
  recordDateTime,
  status,
  schoolName,
  provinceName,
  distirctName,
  dyslexiaPossibility,
  sessionType,
  /*lowReadingPossibility,
  typicalPossibility,*/
  answers,
}) => {
  //const [language, setLanguage] = useState<"en" | "tr">("tr"); // Varsayılan dili Türkçe olarak ayarladık
  const [language, setLanguage] = useState<"en" | "tr" | "ar">(
    (localStorage.getItem("selectedLanguage") as "en" | "tr" | "ar") || "tr"
  );
  const [currentStudentName, setCurrentStudentName] = useState("");

  useEffect(() => {
    if (open) {
      setCurrentStudentName(studentName || "");
    }
  }, [open, studentName]);
  const handleChangeLanguage = (lang: "en" | "tr" | "ar") => {
    setLanguage(lang);
  };
  const intl = useIntl();
  const [tabIndex, setTabIndex] = useState(0);
  const tabQuestions = [
    Object.entries(answers).slice(0, 5),
    Object.entries(answers).slice(5),
  ];

  const COLORS = ["#FF4040", "#E58AA5", "#007FFF"];
  const data = [
    {
      id: "dyslexia",
      label: intl.formatMessage({ id: "dyslexia" }),
      value: Math.round(dyslexiaPossibility * 100),
    },
    {
      id: "notDyslexia",
      label: intl.formatMessage({ id: "notDyslexia" }),
      value: Math.round(100 - dyslexiaPossibility * 100),
    } /*
    {
      id: "typical",
      label: intl.formatMessage({ id: "typical" }),
      value: Math.round(typicalPossibility * 100),
    },*/,
  ];
  const getDyslexiaLevelText = (value: number | null | undefined): string => {
    if (value == null) return "-";

    const percent = Math.round(value * 100);

    if (percent >= 0 && percent < 25)
      return intl.formatMessage({ id: "very_low" });

    if (percent >= 25 && percent < 50) return intl.formatMessage({ id: "low" });

    if (percent >= 50 && percent < 75)
      return intl.formatMessage({ id: "high" });

    if (percent >= 75) return intl.formatMessage({ id: "very_high" });

    return "-";
  };
  const getColor = (value: number) => {
    if (value < 30) return "green";
    if (value < 70) return "orange";
    return "red";
  };
  const MyGauge = ({ percentage }: { percentage: number }) => {
    return (
      <div style={{ width: "100%", maxWidth: "100%", margin: "0 auto" }}>
        <GaugeChart
          id="gauge-chart1"
          nrOfLevels={25}
          arcsLength={[0.2, 0.2, 0.2, 0.2]}
          colors={["#5BE12C", "#F5CD19", "#F58019", "#EA4228"]}
          percent={percentage / 100}
          arcWidth={0.2}
          needleColor="#395359"
          needleBaseColor="#000000"
          hideText={true}
          animate={true}
          // @ts-ignore
          needleScale={0.75}
        />
      </div>
    );
  };
  const MyPyChart: React.FC<{ percentage: number }> = ({ percentage }) => {
    return (
      <PieChart
        series={[
          {
            data: data.map((item, index) => ({
              ...item,
              color: COLORS[index % COLORS.length],
            })),
            highlightScope: {
              fade: "global",
              highlight: "item",
            },
            faded: {
              innerRadius: 30,
              additionalRadius: -30,
              color: "gray",
            },
            valueFormatter,
          },
        ]}
        height={250} // Grafik yüksekliği
        width={500} // Grafik genişliği
      />
    );
  };
  const BarChart: React.FC<{ percentage: number }> = ({ percentage }) => {
    return (
      <Box
        sx={{
          position: "relative",
          width: "80%",
          height: 80,
          borderRadius: 1,
          background: "white",
          overflow: "hidden",
          marginTop: "20px",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            left: `${percentage}%`,
            transform: "translateX(-50%)", // Yüzdeyi tam ortalamak için
            background: "black",
            padding: "4px",
            borderRadius: "5px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "white",
              fontSize: "1rem",
              background: "transparent", // Yazının arka planını şeffaf yap
              whiteSpace: "nowrap", // Taşmayı engelle
            }}
          >
            %{percentage}
          </Typography>
        </Box>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: 60,
            borderRadius: 1,
            background: "linear-gradient(to right, green, yellow, orange, red)",
            overflow: "hidden",
            marginTop: "25px",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              left: `${percentage}%`,
              transform: "translateX(-50%) rotate(180deg)", // Üçgeni aşağıya döndür
              width: 0,
              height: 0,
              borderLeft: "20px solid transparent",
              borderRight: "20px solid transparent",
              borderBottom: "20px solid black", // Üçgenin rengi ve yüksekliği
            }}
          />
        </Box>
      </Box>
    );
  };

  const valueFormatter = (value: { value: number }) => `${value.value}%`;
  const getS3ImageUrl = (sessionID: number, textID: number) => {
    const bucketName = "eye-lexia";
    const region = "eu-central-1";
    const randomQueryParam = `?t=${new Date().getTime()}`;
    return `https://${bucketName}.s3.${region}.amazonaws.com/${sessionID}_${textID}_heatmap.png${randomQueryParam}`;
  };
  const getS3VoiceUrlMp4 = (sessionID: number, textID: number): string => {
    const bucketName = "eye-lexia";
    const region = "eu-central-1";
    const timestamp = `?t=${new Date().getTime()}`;

    return `https://${bucketName}.s3.${region}.amazonaws.com/${sessionID}_${textID}_record.mp4${timestamp}`;
  };

  const getS3VoiceUrl = (sessionID: number, textID: number): string => {
    const bucketName = "eye-lexia";
    const region = "eu-central-1";
    const timestamp = `?t=${new Date().getTime()}`;

    return `https://${bucketName}.s3.${region}.amazonaws.com/${sessionID}_${textID}_record.wav${timestamp}`;
  };
  const [showVideo, setShowVideo] = useState(true);
  useEffect(() => {
    setShowVideo(true);
  }, [sessionID, tabIndex]);
  const getS3PlayableUrl = async (sessionID: number, textID: number) => {
    const bucket = "eye-lexia";
    const region = "eu-central-1";
    const ts = `?t=${new Date().getTime()}`;

    const wav = `https://${bucket}.s3.${region}.amazonaws.com/${sessionID}_${textID}_record.wav${ts}`;
    const mp4 = `https://${bucket}.s3.${region}.amazonaws.com/${sessionID}_${textID}_record.mp4${ts}`;

    if (await fileExists(wav)) return wav;
    if (await fileExists(mp4)) return mp4;

    return null;
  };
  const [fileUrl, setFileUrl] = useState<string | null>(null);

  useEffect(() => {
    const textID = tabIndex === 0 ? 1 : 3;

    getS3PlayableUrl(sessionID, textID).then((url) => {
      setFileUrl(url);
    });
  }, [tabIndex, sessionID]);
  const fileExists = async (url: string) => {
    try {
      const res = await fetch(url, { method: "HEAD" });
      return res.ok;
    } catch {
      return false;
    }
  };
  /*const getS3VoiceUrl = (sessionID: number, textID: number) => {
    const bucketName = "eye-lexia";
    const region = "eu-central-1";
    const randomQueryParam = `?t=${new Date().getTime()}`;
    return `https://${bucketName}.s3.${region}.amazonaws.com/${sessionID}_${textID}_record.mp4${randomQueryParam}`;
  };*/

  const getStatusText = (status: string) => {
    switch (status) {
      case "3":
        return `${intl.formatMessage({
          id: "typical",
        })}`;
      case "2":
        return `${intl.formatMessage({
          id: "lowreading",
        })}`;
      case "1":
        return `${intl.formatMessage({
          id: "dyslexia",
        })}`;
      default:
        return `${intl.formatMessage({
          id: "incorrectsession",
        })}`;
    }
  };
  const [questions, setQuestions] = useState<Question[]>([]);
  const [loading, setLoading] = useState(true);
  const [questionsAnswers, setQuestionsAnswers] = useState<{
    [key: number]: string[];
  }>({});
  useEffect(() => {
    const fetchQuestionsData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://eyelexia.eyesoft.com.tr/api/get-questions`
        );
        setQuestions(response.data);
      } catch (error) {
        console.error("Error fetching students data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchQuestionsData();
  }, []);
  useEffect(() => {
    if (questions.length > 0) {
      const newQuestionsAnswers: { [key: number]: string[] } = {};

      questions.forEach((question) => {
        newQuestionsAnswers[question.ID] = [
          question.Question,
          question.Answer1,
          question.Answer2,
          question.Answer3,
          question.Answer4,
        ];
      });

      setQuestionsAnswers(newQuestionsAnswers);
    }
  }, [questions]);

  const question = (index: number) => {
    const questionArray = questionsAnswers[index];

    if (!questionArray) {
      return `${intl.formatMessage({
        id: "unsuccessindex",
      })}`;
    }

    return questionArray[0];
  };
  const answer = (index: number, answerIndex: number) => {
    const questionArray = questionsAnswers[index];

    if (!questionArray) {
      return `${intl.formatMessage({
        id: "unsuccessindex",
      })}`;
    }

    return questionArray[answerIndex];
  };
  const downloadPDF = async () => {
    const doc = new jsPDF();
    doc.addFileToVFS("arial.ttf", arialFont);
    doc.addFileToVFS("arial_bold.ttf", arialBoldFont);
    doc.addFont("arial.ttf", "arial", "normal");
    doc.addFont("arial_bold.ttf", "arialbold", "bold");
    doc.setFont("arial");

    // Başlık
    doc.setFontSize(22);
    const pageWidth = doc.internal.pageSize.width;
    const textWidth = doc.getTextWidth(schoolName);
    const xPosition = (pageWidth - textWidth) / 2;
    const logoWidth = 20;
    const logoHeight = 5;

    // Logo sağ üst köşede
    doc.addImage(
      logo,
      "PNG",
      pageWidth - logoWidth - 10,
      10,
      logoWidth,
      logoHeight
    ); // Sağ üst köşe

    doc.text(`${intl.formatMessage({ id: "meb" })}`, xPosition, 10);

    // Alt Başlık
    doc.setFontSize(14);
    doc.setFont("arialbold", "bold");
    doc.text(`${intl.formatMessage({ id: "studentinformation" })}`, 20, 20);
    const statustext = getStatusText(status);
    doc.setFont("arial", "normal");
    const columnWidths = [50, 130]; // Label ve value sütunlarının genişliği
    let yPosition = 25;

    // Öğrenci bilgileri ve hücre boyutları
    const studentData = [
      { label: `${intl.formatMessage({ id: "name" })}`, value: studentName },
      /*{
        label: `${intl.formatMessage({ id: "currentdiagnosisstatus" })}`,
        value: statustext,
      },*/
      {
        label: `${intl.formatMessage({ id: "dyslexia%" })}`,
        value:
          sessionType === 2 || sessionType === 3 || dyslexiaPossibility === 0
            ? "-"
            : getDyslexiaLevelText(dyslexiaPossibility),
      },
      /*{
        label: `${intl.formatMessage({ id: "lowreading" })}`,
        value: `%${Math.round(lowReadingPossibility * 100)}`,
      },
      {
        label: `${intl.formatMessage({ id: "typical" })}`,
        value: `%${Math.round(typicalPossibility * 100)}`,
      },*/
      {
        label: `${intl.formatMessage({ id: "diagnosisdate" })}`,
        value: recordDateTime,
      },
      {
        label: `${intl.formatMessage({ id: "province" })}`,
        value: provinceName,
      },
      {
        label: `${intl.formatMessage({ id: "district" })}`,
        value: distirctName,
      },
      {
        label: `${intl.formatMessage({ id: "schoolname" })}`,
        value: schoolName,
      },
    ];
    if (sessionNote && sessionNote.trim() !== "") {
      studentData.push({
        label: `${intl.formatMessage({ id: "note" })}`,
        value: sessionNote,
      });
    }
    // Tablonun Başlık ve Değerlerini hizalayarak ekle
    studentData.forEach((data, index) => {
      const labelWidth = columnWidths[0];
      const valueWidth = columnWidths[1];

      // Etiket hücresini yaz
      doc.text(data.label, 40, yPosition + 5); // Etiket metnini yaz (5 px padding)

      // Değer hücresini yaz
      doc.text(data.value || "", 40 + labelWidth, yPosition + 5); // Değer metnini yaz (boş bırakılabilir)

      yPosition += 7; // Satır yüksekliği (5px padding ile)
    });
    let currentYPosition = 110;
    const pageHeight = doc.internal.pageSize.height;

    for (let i = 0; i < 2; i++) {
      try {
        // Sadece sessionType 3 değilse resimleri ekle
        if (sessionType !== 3) {
          const imgData = await fetch(
            i === 0 ? getS3ImageUrl(sessionID, 1) : getS3ImageUrl(sessionID, 3)
          )
            .then((response) => response.blob())
            .then(
              (blob) =>
                new Promise<string>((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onloadend = () => resolve(reader.result as string);
                  reader.onerror = reject;
                  reader.readAsDataURL(blob);
                })
            );
          if (currentYPosition + 100 + logoHeight > pageHeight) {
            doc.addPage();
            currentYPosition = 30;

            // Yeni sayfada logo ve başlık ekle
            doc.addImage(
              logo,
              "PNG",
              (pageWidth - logoWidth) / 2,
              10,
              logoWidth,
              logoHeight
            );
            currentYPosition = 60;
          }

          doc.setFontSize(14);
          doc.setFont("arialbold", "bold");
          if (i == 0) {
            doc.text(
              `${intl.formatMessage({ id: "narrativetextoverviewmap" })}`,
              20,
              currentYPosition
            );
          } else {
            doc.text(
              `${intl.formatMessage({ id: "informativetextoverviewmap" })}`,
              20,
              currentYPosition
            );
          }
          currentYPosition += 5;

          // Resim ekle
          doc.addImage(imgData, "PNG", 10, currentYPosition, 180, 100);
          currentYPosition += 105;

          // Sorular ve Yanıtlar Başlığı
          doc.setFontSize(12);
          doc.setFont("arialbold", "bold");
          doc.text(
            `${intl.formatMessage({ id: "questionsandanswers" })}`,
            20,
            currentYPosition
          );
        }
        currentYPosition += 10;
        doc.setFont("arial", "normal");

        const questionsForSession = tabQuestions[i];
        questionsForSession.forEach(([key, answers]) => {
          doc.setFontSize(10);
          doc.text(`• ${question(Number(key) + 1)}:`, 40, currentYPosition);
          currentYPosition += 5;
          answers.forEach((answerIndex) => {
            const answerText = answer(Number(key) + 1, Number(answerIndex));
            const isCorrect = checkAnswer(Number(key) + 1, Number(answerIndex));

            if (isCorrect) {
              doc.setTextColor(0, 128, 0);
            } else {
              doc.setTextColor(255, 0, 0);
            }
            doc.text(`  - ${answerText}`, 40, currentYPosition);
            currentYPosition += 5;
          });
          doc.setTextColor(0, 0, 0);
        });
      } catch (error) {
        console.error(`${intl.formatMessage({ id: "imageerror" })}`, error);
      }
    }

    doc.save(`${studentName} - ${recordDateTime}.pdf`);
  };
  const checkAnswer = (questionID: number, answerIndex: number) => {
    const question = questions.find((q) => q.ID === questionID);

    if (!question) {
      return false;
    }

    return question.Correct === answerIndex;
  };

  useEffect(() => {
    if (sessionType === 3 && tabIndex !== 2) {
      setTabIndex(2);
    }
  }, [sessionType]);

  return (
    <IntlProvider
      locale={language}
      messages={messages[language] as unknown as Record<string, string>}
    >
      <ThemeProvider theme={theme}>
        <Modal
          open={open}
          onClose={onClose}
          aria-labelledby="photo-modal-title"
        >
          <Box
            id="modal-content"
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "90%",
              height: "90%",
              bgcolor: "background.paper",
              border: "2px solid #000",
              boxShadow: 24,
              p: 4,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <IconButton
              onClick={onClose}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "grey.500",
              }}
            >
              <CloseIcon />
            </IconButton>
            <Box
              sx={{
                width: "100%",
                height: "95%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                id="photo-modal-title"
                variant="h6"
                component="h2"
                sx={{
                  fontSize: {
                    xs: "0.8rem", // Daha küçük ekranlar için
                    sm: "1rem",
                    md: "1.2rem",
                    lg: "1.8rem", // Daha büyük ekranlar için
                  },
                  textAlign: "center",
                }}
              >
                <strong>{currentStudentName}</strong>
              </Typography>

              <Tabs
                value={tabIndex}
                onChange={(e, newIndex) => setTabIndex(newIndex)}
                sx={{
                  width: "100%",
                  height: "5%",
                  marginTop: "1%",
                  backgroundColor: "#f8f9fa", // Hafif gri arka plan
                  borderRadius: "8px", // Köşeleri yumuşat
                  padding: "5px", // Tıklama alanını büyüt
                }}
              >
                {sessionType !== 3 && (
                  <Tab
                    value={0}
                    sx={{
                      fontSize: {
                        xs: "0.6rem",
                        sm: "0.8rem",
                        md: "1rem",
                        lg: "1.2rem",
                      },
                      padding: "12px 16px", // Daha büyük tıklama alanı
                      fontWeight: tabIndex === 0 ? "bold" : "normal", // Seçili sekme kalın olsun
                      color: tabIndex === 0 ? "#007bff" : "#333", // Seçili sekme mavi
                      borderBottom:
                        tabIndex === 0 ? "3px solid #007bff" : "none", // Seçili sekmeye alt çizgi
                      transition: "all 0.3s ease",
                      "&:hover": {
                        color: "#395359", // Hover rengi koyu mavi
                        transform: "scale(1.05)", // Hafif büyüme efekti
                      },
                    }}
                    label={intl.formatMessage({ id: "narrative" })}
                  />
                )}
                {sessionType !== 3 && (
                  <Tab
                    value={1}
                    sx={{
                      fontSize: {
                        xs: "0.6rem",
                        sm: "0.8rem",
                        md: "1rem",
                        lg: "1.2rem",
                      },
                      padding: "12px 16px",
                      fontWeight: tabIndex === 1 ? "bold" : "normal",
                      color: tabIndex === 1 ? "#395359" : "#333",
                      borderBottom:
                        tabIndex === 1 ? "3px solid #395359" : "none",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        color: "#395359",
                        transform: "scale(1.05)",
                      },
                    }}
                    label={intl.formatMessage({ id: "informative" })}
                  />
                )}
                <Tab
                  value={2}
                  sx={{
                    fontSize: {
                      xs: "0.6rem",
                      sm: "0.8rem",
                      md: "1rem",
                      lg: "1.2rem",
                    },
                    padding: "12px 16px",
                    fontWeight: tabIndex === 2 ? "bold" : "normal",
                    color: tabIndex === 2 ? "#395359" : "#333",
                    borderBottom: tabIndex === 2 ? "3px solid #395359" : "none",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      color: "#395359",
                      transform: "scale(1.05)",
                    },
                  }}
                  label={intl.formatMessage({ id: "statusresults" })}
                />
              </Tabs>

              <Box
                sx={{
                  width: "100%",
                  height: "80%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {tabIndex === 2 ? (
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "row", // Grafik solda, not sağda olacak
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "20px",
                      overflow: "hidden",
                    }}
                  >
                    {/* Sol Taraftaki Grafik */}
                    <Box
                      sx={{
                        width: "50%", // Grafiğin genişliği
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginBottom: 8,
                        position: "relative",
                      }}
                    >
                      {sessionType !== 2 && sessionType !== 3 && (
                        /*<BarChart
                          percentage={Math.round(dyslexiaPossibility * 100)}
                        />*/
                        <MyGauge
                          percentage={Math.round(dyslexiaPossibility * 100)}
                        />
                        /*<MyPyChart
                          percentage={Math.round(dyslexiaPossibility * 100)}
                        />*/
                      )}
                      {sessionType !== 2 && sessionType !== 3 && (
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: "1.0rem", md: "1.8rem" },
                            position: "center",
                            top: 0,
                            left: 0,
                            fontWeight: "bold",
                            color:
                              dyslexiaPossibility <= 0.25
                                ? "#5BE12C"
                                : dyslexiaPossibility <= 0.5
                                ? "#F5CD19"
                                : dyslexiaPossibility <= 0.75
                                ? "#F58019"
                                : "#EA4228",
                          }}
                        >
                          {intl.formatMessage({ id: "dyslexia%" })}:
                          {getDyslexiaLevelText(dyslexiaPossibility)}
                        </Typography>
                      )}
                    </Box>

                    <Box
                      sx={{
                        width: "40%", // Notun genişliği
                        height: "90%",
                        overflowY: "auto", // Kaydırma çubuğu ekler
                        padding: "10px",
                        borderRadius: 2,
                        border: "4px solid #A6A6A6", // Çerçeve ekler
                        backgroundColor: "transparent", // Arka plan rengini kaldırır
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: { xs: "1rem", md: "1.6rem" }, // Başlık için daha büyük font
                          fontWeight: "bold", // Başlık kalın olsun
                          textAlign: "center",
                          display: "block", // Yeni satıra atması için
                          marginBottom: "5px", // Başlık ile içerik arasına boşluk ekler
                        }}
                      >
                        {intl.formatMessage({ id: "note" })}
                      </Typography>

                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: { xs: "0.75rem", md: "1.4rem" }, // İçerik biraz daha küçük
                          textAlign: "center",
                        }}
                      >
                        {sessionNote}
                      </Typography>
                    </Box>
                  </Box>
                ) : (
                  <>
                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          height: "100%",
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={
                            tabIndex === 0
                              ? getS3ImageUrl(sessionID, 1)
                              : getS3ImageUrl(sessionID, 3)
                          }
                          alt={`Okuma Metni ${tabIndex + 1}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            maxWidth: "800px",
                          }}
                        />
                        {/*fileUrl && (
                          <video
                            controls
                            width="60%"
                            height="10%"
                            key={tabIndex}
                          >
                            <source src={fileUrl} type="video/mp4" />
                          </video>
                        )*/}

                        {showVideo && (
                          <video
                            controls
                            width="60%"
                            height="10%"
                            key={tabIndex}
                            onError={() => {
                              setShowVideo(false); // 👈 doğru yol
                            }}
                          >
                            <source
                              src={
                                tabIndex === 0
                                  ? getS3VoiceUrl(sessionID, 1)
                                  : getS3VoiceUrl(sessionID, 3)
                              }
                              type="video/mp4"
                            />
                          </video>
                        )}
                      </Box>
                      <Box
                        sx={{
                          width: "100%",
                          height: "100%",
                          maxWidth: "800px",
                          flex: 1,
                        }}
                      >
                        <Typography
                          sx={{
                            width: "100%",
                            height: "5%",
                            fontWeight: "bold",
                            marginTop: "3%",
                            fontSize: { xs: "1.0rem", md: "1.2rem" },
                          }}
                        >
                          {intl.formatMessage({
                            id: "questions",
                          })}
                          :
                        </Typography>
                        <ul>
                          {tabQuestions[tabIndex].map(([key, answers]) => {
                            const questionID = Number(key) + 1; // Sorunun ID'sini al
                            const correctAnswerIndex =
                              questionsAnswers[questionID]?.[0]; // Sorunun doğru cevabını al
                            return (
                              <li key={key}>
                                <Typography
                                  sx={{
                                    fontSize: {
                                      xs: "0.3rem",
                                      sm: "0.5rem",
                                      md: "0.8rem",
                                      lg: "1.2rem",
                                    },
                                  }}
                                >
                                  <strong>{question(questionID)}</strong>
                                </Typography>
                                {answers.map((answerText, index) => {
                                  const isCorrect = checkAnswer(
                                    questionID,
                                    Number(answerText)
                                  ); // Cevabın doğru olup olmadığını kontrol et
                                  return (
                                    <Box
                                      key={index}
                                      sx={{
                                        display: "flex",
                                        alignItems: "center", // Dikey hizalama
                                        marginLeft: 2,
                                        color: isCorrect ? "green" : "red", // Doğru cevap için yeşil, yanlış için kırmızı
                                      }}
                                    >
                                      {isCorrect ? (
                                        <CheckCircleIcon
                                          sx={{
                                            color: "green",
                                            mr: 1,
                                            fontSize: {
                                              xs: "0.3rem",
                                              sm: "0.5rem",
                                              md: "0.8rem",
                                              lg: "1.2rem",
                                            },
                                          }}
                                        />
                                      ) : (
                                        <CancelIcon
                                          sx={{
                                            color: "red",
                                            mr: 1,
                                            fontSize: {
                                              xs: "0.3rem",
                                              sm: "0.5rem",
                                              md: "0.8rem",
                                              lg: "1.2rem",
                                            },
                                          }}
                                        /> // Yanlış ikon solunda görünür
                                      )}
                                      <Typography
                                        sx={{
                                          fontSize: {
                                            xs: "0.3rem",
                                            sm: "0.5rem",
                                            md: "0.8rem",
                                            lg: "1.2rem",
                                          },
                                          color: isCorrect ? "green" : "red",
                                        }}
                                      >
                                        {answer(
                                          Number(key) + 1,
                                          Number(answerText)
                                        )}
                                      </Typography>
                                    </Box>
                                  );
                                })}
                              </li>
                            );
                          })}
                        </ul>
                      </Box>
                    </Box>
                  </>
                )}
              </Box>
            </Box>
            <Box
              sx={{
                width: "99%",
                height: "5%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                onClick={downloadPDF}
                variant="contained"
                sx={{
                  width: "20%",
                  height: "100%",
                  fontSize: {
                    xs: "0.2rem",
                    sm: "0.3rem",
                    md: "0.6rem",
                    lg: "1.0rem",
                  },
                  padding: {
                    xs: "2px 4px", // Küçük ekranlar için padding
                    sm: "4px 8px", // Orta ekranlar
                    md: "6px 12px", // Büyük ekranlar için padding
                    lg: "8px 16px",
                  },
                }}
              >
                {intl.formatMessage({
                  id: "readdatadownload",
                })}
              </Button>
            </Box>
          </Box>
        </Modal>
      </ThemeProvider>
    </IntlProvider>
  );
};

export default ReadMapModal;
